// This file is AUTOGENERATED, do not edit it manually!!!

import { common as commonde } from './commonResx.de';
import { common as commonen } from './commonResx.en';
import { common as commonen_risk } from './commonResx.en_risk';
import { common as commones } from './commonResx.es';
import { common as commonfr } from './commonResx.fr';
import { common as commonit } from './commonResx.it';
import { common as commonnl } from './commonResx.nl';
import { common as commonpl } from './commonResx.pl';
import { common as commonpt } from './commonResx.pt';
import { common as commonru } from './commonResx.ru';
import { common as commonsk } from './commonResx.sk';
import { common as commonsv } from './commonResx.sv';
import { common as commontr } from './commonResx.tr';

const langMap: { [k: string]: Partial<typeof commonen> } = {
    de: commonde,
    en: commonen,
    en_risk: commonen_risk,
    es: commones,
    fr: commonfr,
    it: commonit,
    nl: commonnl,
    pl: commonpl,
    pt: commonpt,
    ru: commonru,
    sk: commonsk,
    sv: commonsv,
    tr: commontr,
};

/* tslint:disable: max-line-length */
export const commonResx = {
    get activity() {
        return langMap[ep.resxCulture].activity || langMap.en.activity;
    },
    get add_check_list_item_placeholder() {
        return langMap[ep.resxCulture].add_check_list_item_placeholder || langMap.en.add_check_list_item_placeholder;
    },
    get add_checklist_label() {
        return langMap[ep.resxCulture].add_checklist_label || langMap.en.add_checklist_label;
    },
    get add_more() {
        return langMap[ep.resxCulture].add_more || langMap.en.add_more;
    },
    get add_reaction_title() {
        return langMap[ep.resxCulture].add_reaction_title || langMap.en.add_reaction_title;
    },
    get ai() {
        return langMap[ep.resxCulture].ai || langMap.en.ai;
    },
    get ai_analyzing() {
        return langMap[ep.resxCulture].ai_analyzing || langMap.en.ai_analyzing;
    },
    get ai_building() {
        return langMap[ep.resxCulture].ai_building || langMap.en.ai_building;
    },
    get ai_description() {
        return langMap[ep.resxCulture].ai_description || langMap.en.ai_description;
    },
    get ai_forecast() {
        return langMap[ep.resxCulture].ai_forecast || langMap.en.ai_forecast;
    },
    get ai_forecast_date() {
        return langMap[ep.resxCulture].ai_forecast_date || langMap.en.ai_forecast_date;
    },
    get ai_how_works() {
        return langMap[ep.resxCulture].ai_how_works || langMap.en.ai_how_works;
    },
    get ai_not_enough_data() {
        return langMap[ep.resxCulture].ai_not_enough_data || langMap.en.ai_not_enough_data;
    },
    get ai_planned_date() {
        return langMap[ep.resxCulture].ai_planned_date || langMap.en.ai_planned_date;
    },
    get ai_result() {
        return langMap[ep.resxCulture].ai_result || langMap.en.ai_result;
    },
    get ai_reviewing() {
        return langMap[ep.resxCulture].ai_reviewing || langMap.en.ai_reviewing;
    },
    get apply() {
        return langMap[ep.resxCulture].apply || langMap.en.apply;
    },
    get available() {
        return langMap[ep.resxCulture].available || langMap.en.available;
    },
    get back() {
        return langMap[ep.resxCulture].back || langMap.en.back;
    },
    get CanChangeWorkflowForProjectOutdatedData() {
        return langMap[ep.resxCulture].CanChangeWorkflowForProjectOutdatedData || langMap.en.CanChangeWorkflowForProjectOutdatedData;
    },
    get CanDeleteCategoryHasTask() {
        return langMap[ep.resxCulture].CanDeleteCategoryHasTask || langMap.en.CanDeleteCategoryHasTask;
    },
    get CanDeletePriorityHasProject() {
        return langMap[ep.resxCulture].CanDeletePriorityHasProject || langMap.en.CanDeletePriorityHasProject;
    },
    get CanDeletePriorityHasTask() {
        return langMap[ep.resxCulture].CanDeletePriorityHasTask || langMap.en.CanDeletePriorityHasTask;
    },
    get CanDeletePriorityIsInternal() {
        return langMap[ep.resxCulture].CanDeletePriorityIsInternal || langMap.en.CanDeletePriorityIsInternal;
    },
    get CanDeleteStatusIsWorkflowTypeStatus() {
        return langMap[ep.resxCulture].CanDeleteStatusIsWorkflowTypeStatus || langMap.en.CanDeleteStatusIsWorkflowTypeStatus;
    },
    get CanDeleteStatusUsed() {
        return langMap[ep.resxCulture].CanDeleteStatusUsed || langMap.en.CanDeleteStatusUsed;
    },
    get CanDeleteThresholdIsInternal() {
        return langMap[ep.resxCulture].CanDeleteThresholdIsInternal || langMap.en.CanDeleteThresholdIsInternal;
    },
    get CanDeleteVacationTypeDefault() {
        return langMap[ep.resxCulture].CanDeleteVacationTypeDefault || langMap.en.CanDeleteVacationTypeDefault;
    },
    get CanDeleteVacationTypeHasVacation() {
        return langMap[ep.resxCulture].CanDeleteVacationTypeHasVacation || langMap.en.CanDeleteVacationTypeHasVacation;
    },
    get CanDeleteWorkflowIsSingle() {
        return langMap[ep.resxCulture].CanDeleteWorkflowIsSingle || langMap.en.CanDeleteWorkflowIsSingle;
    },
    get CanDeleteWorkflowIsUsed() {
        return langMap[ep.resxCulture].CanDeleteWorkflowIsUsed || langMap.en.CanDeleteWorkflowIsUsed;
    },
    get CanDisableStatusIsUsed() {
        return langMap[ep.resxCulture].CanDisableStatusIsUsed || langMap.en.CanDisableStatusIsUsed;
    },
    get CanDisableStatusIsWorkflowTypeStatus() {
        return langMap[ep.resxCulture].CanDisableStatusIsWorkflowTypeStatus || langMap.en.CanDisableStatusIsWorkflowTypeStatus;
    },
    get CanEdit_Task_AccessDenied() {
        return langMap[ep.resxCulture].CanEdit_Task_AccessDenied || langMap.en.CanEdit_Task_AccessDenied;
    },
    get CanEditValueThresholdIsInternal() {
        return langMap[ep.resxCulture].CanEditValueThresholdIsInternal || langMap.en.CanEditValueThresholdIsInternal;
    },
    get CanSetWorkflowTypeStatusIsWorkflowTypeStatus() {
        return langMap[ep.resxCulture].CanSetWorkflowTypeStatusIsWorkflowTypeStatus || langMap.en.CanSetWorkflowTypeStatusIsWorkflowTypeStatus;
    },
    get change() {
        return langMap[ep.resxCulture].change || langMap.en.change;
    },
    get ChangeProjectProgressError() {
        return langMap[ep.resxCulture].ChangeProjectProgressError || langMap.en.ChangeProjectProgressError;
    },
    get ChangeTaskProgressError() {
        return langMap[ep.resxCulture].ChangeTaskProgressError || langMap.en.ChangeTaskProgressError;
    },
    get check_all_label() {
        return langMap[ep.resxCulture].check_all_label || langMap.en.check_all_label;
    },
    get checklist_name() {
        return langMap[ep.resxCulture].checklist_name || langMap.en.checklist_name;
    },
    get column_group_custom_fields() {
        return langMap[ep.resxCulture].column_group_custom_fields || langMap.en.column_group_custom_fields;
    },
    get column_group_custom_fields_user() {
        return langMap[ep.resxCulture].column_group_custom_fields_user || langMap.en.column_group_custom_fields_user;
    },
    get columns() {
        return langMap[ep.resxCulture].columns || langMap.en.columns;
    },
    get Completed_Projects() {
        return langMap[ep.resxCulture].Completed_Projects || langMap.en.Completed_Projects;
    },
    get Completed_Tasks() {
        return langMap[ep.resxCulture].Completed_Tasks || langMap.en.Completed_Tasks;
    },
    get Copy_Text() {
        return langMap[ep.resxCulture].Copy_Text || langMap.en.Copy_Text;
    },
    get copyPostfix() {
        return langMap[ep.resxCulture].copyPostfix || langMap.en.copyPostfix;
    },
    get create() {
        return langMap[ep.resxCulture].create || langMap.en.create;
    },
    get created_by() {
        return langMap[ep.resxCulture].created_by || langMap.en.created_by;
    },
    get creation_date() {
        return langMap[ep.resxCulture].creation_date || langMap.en.creation_date;
    },
    get current_plan() {
        return langMap[ep.resxCulture].current_plan || langMap.en.current_plan;
    },
    get dates() {
        return langMap[ep.resxCulture].dates || langMap.en.dates;
    },
    get delete_checklist_label() {
        return langMap[ep.resxCulture].delete_checklist_label || langMap.en.delete_checklist_label;
    },
    get description_title() {
        return langMap[ep.resxCulture].description_title || langMap.en.description_title;
    },
    get edit_check_list_item_placeholder() {
        return langMap[ep.resxCulture].edit_check_list_item_placeholder || langMap.en.edit_check_list_item_placeholder;
    },
    get Edit_Text() {
        return langMap[ep.resxCulture].Edit_Text || langMap.en.Edit_Text;
    },
    get emoji() {
        return langMap[ep.resxCulture].emoji || langMap.en.emoji;
    },
    get empty_list() {
        return langMap[ep.resxCulture].empty_list || langMap.en.empty_list;
    },
    get error_reload() {
        return langMap[ep.resxCulture].error_reload || langMap.en.error_reload;
    },
    get export() {
        return langMap[ep.resxCulture].export || langMap.en.export;
    },
    get export_csv() {
        return langMap[ep.resxCulture].export_csv || langMap.en.export_csv;
    },
    get export_pdf() {
        return langMap[ep.resxCulture].export_pdf || langMap.en.export_pdf;
    },
    get filters() {
        return langMap[ep.resxCulture].filters || langMap.en.filters;
    },
    get freeze() {
        return langMap[ep.resxCulture].freeze || langMap.en.freeze;
    },
    get from() {
        return langMap[ep.resxCulture].from || langMap.en.from;
    },
    get general() {
        return langMap[ep.resxCulture].general || langMap.en.general;
    },
    get global_search() {
        return langMap[ep.resxCulture].global_search || langMap.en.global_search;
    },
    get global_search_text() {
        return langMap[ep.resxCulture].global_search_text || langMap.en.global_search_text;
    },
    get GotIt() {
        return langMap[ep.resxCulture].GotIt || langMap.en.GotIt;
    },
    get group_by() {
        return langMap[ep.resxCulture].group_by || langMap.en.group_by;
    },
    get group_by_template() {
        return langMap[ep.resxCulture].group_by_template || langMap.en.group_by_template;
    },
    get here() {
        return langMap[ep.resxCulture].here || langMap.en.here;
    },
    get hourly_rate_unit() {
        return langMap[ep.resxCulture].hourly_rate_unit || langMap.en.hourly_rate_unit;
    },
    get icons() {
        return langMap[ep.resxCulture].icons || langMap.en.icons;
    },
    get in() {
        return langMap[ep.resxCulture].in || langMap.en.in;
    },
    get in_use() {
        return langMap[ep.resxCulture].in_use || langMap.en.in_use;
    },
    get items_text() {
        return langMap[ep.resxCulture].items_text || langMap.en.items_text;
    },
    get job_role() {
        return langMap[ep.resxCulture].job_role || langMap.en.job_role;
    },
    get label_custom_date_range() {
        return langMap[ep.resxCulture].label_custom_date_range || langMap.en.label_custom_date_range;
    },
    get label_daily() {
        return langMap[ep.resxCulture].label_daily || langMap.en.label_daily;
    },
    get label_monthly() {
        return langMap[ep.resxCulture].label_monthly || langMap.en.label_monthly;
    },
    get label_weekly() {
        return langMap[ep.resxCulture].label_weekly || langMap.en.label_weekly;
    },
    get label_yearly() {
        return langMap[ep.resxCulture].label_yearly || langMap.en.label_yearly;
    },
    get least_likely() {
        return langMap[ep.resxCulture].least_likely || langMap.en.least_likely;
    },
    get month() {
        return langMap[ep.resxCulture].month || langMap.en.month;
    },
    get MoreActions() {
        return langMap[ep.resxCulture].MoreActions || langMap.en.MoreActions;
    },
    get most_likely() {
        return langMap[ep.resxCulture].most_likely || langMap.en.most_likely;
    },
    get move_down() {
        return langMap[ep.resxCulture].move_down || langMap.en.move_down;
    },
    get move_up() {
        return langMap[ep.resxCulture].move_up || langMap.en.move_up;
    },
    get name_title() {
        return langMap[ep.resxCulture].name_title || langMap.en.name_title;
    },
    get next_month() {
        return langMap[ep.resxCulture].next_month || langMap.en.next_month;
    },
    get next_week() {
        return langMap[ep.resxCulture].next_week || langMap.en.next_week;
    },
    get no() {
        return langMap[ep.resxCulture].no || langMap.en.no;
    },
    get no_available_filters() {
        return langMap[ep.resxCulture].no_available_filters || langMap.en.no_available_filters;
    },
    get no_data_to_display() {
        return langMap[ep.resxCulture].no_data_to_display || langMap.en.no_data_to_display;
    },
    get no_data_to_display_for_widget() {
        return langMap[ep.resxCulture].no_data_to_display_for_widget || langMap.en.no_data_to_display_for_widget;
    },
    get NoPermissionToArchiveProject() {
        return langMap[ep.resxCulture].NoPermissionToArchiveProject || langMap.en.NoPermissionToArchiveProject;
    },
    get not_calculated() {
        return langMap[ep.resxCulture].not_calculated || langMap.en.not_calculated;
    },
    get not_in_use() {
        return langMap[ep.resxCulture].not_in_use || langMap.en.not_in_use;
    },
    get pause() {
        return langMap[ep.resxCulture].pause || langMap.en.pause;
    },
    get PortfolioLimitError() {
        return langMap[ep.resxCulture].PortfolioLimitError || langMap.en.PortfolioLimitError;
    },
    get previous_month() {
        return langMap[ep.resxCulture].previous_month || langMap.en.previous_month;
    },
    get previous_week() {
        return langMap[ep.resxCulture].previous_week || langMap.en.previous_week;
    },
    get previous_year() {
        return langMap[ep.resxCulture].previous_year || langMap.en.previous_year;
    },
    get qb_disconnect_denied() {
        return langMap[ep.resxCulture].qb_disconnect_denied || langMap.en.qb_disconnect_denied;
    },
    get quarter() {
        return langMap[ep.resxCulture].quarter || langMap.en.quarter;
    },
    get quick_search_placeholder() {
        return langMap[ep.resxCulture].quick_search_placeholder || langMap.en.quick_search_placeholder;
    },
    get quick_search_placeholder_for_archive() {
        return langMap[ep.resxCulture].quick_search_placeholder_for_archive || langMap.en.quick_search_placeholder_for_archive;
    },
    get RateLimitExceededByAccount() {
        return langMap[ep.resxCulture].RateLimitExceededByAccount || langMap.en.RateLimitExceededByAccount;
    },
    get RateLimitExceededByUser() {
        return langMap[ep.resxCulture].RateLimitExceededByUser || langMap.en.RateLimitExceededByUser;
    },
    get read_more() {
        return langMap[ep.resxCulture].read_more || langMap.en.read_more;
    },
    get RecordConversionToActivityDifferentWorkflows() {
        return langMap[ep.resxCulture].RecordConversionToActivityDifferentWorkflows || langMap.en.RecordConversionToActivityDifferentWorkflows;
    },
    get records() {
        return langMap[ep.resxCulture].records || langMap.en.records;
    },
    get remove_checklist_item_label() {
        return langMap[ep.resxCulture].remove_checklist_item_label || langMap.en.remove_checklist_item_label;
    },
    get request_resources() {
        return langMap[ep.resxCulture].request_resources || langMap.en.request_resources;
    },
    get reset_timer_title() {
        return langMap[ep.resxCulture].reset_timer_title || langMap.en.reset_timer_title;
    },
    get resource_type_label() {
        return langMap[ep.resxCulture].resource_type_label || langMap.en.resource_type_label;
    },
    get resume() {
        return langMap[ep.resxCulture].resume || langMap.en.resume;
    },
    get role() {
        return langMap[ep.resxCulture].role || langMap.en.role;
    },
    get schedule_hours() {
        return langMap[ep.resxCulture].schedule_hours || langMap.en.schedule_hours;
    },
    get security_group() {
        return langMap[ep.resxCulture].security_group || langMap.en.security_group;
    },
    get select() {
        return langMap[ep.resxCulture].select || langMap.en.select;
    },
    get share() {
        return langMap[ep.resxCulture].share || langMap.en.share;
    },
    get short_quarter0() {
        return langMap[ep.resxCulture].short_quarter0 || langMap.en.short_quarter0;
    },
    get short_quarter1() {
        return langMap[ep.resxCulture].short_quarter1 || langMap.en.short_quarter1;
    },
    get short_quarter2() {
        return langMap[ep.resxCulture].short_quarter2 || langMap.en.short_quarter2;
    },
    get short_quarter3() {
        return langMap[ep.resxCulture].short_quarter3 || langMap.en.short_quarter3;
    },
    get show() {
        return langMap[ep.resxCulture].show || langMap.en.show;
    },
    get show_template() {
        return langMap[ep.resxCulture].show_template || langMap.en.show_template;
    },
    get skillsDeleteConfirm() {
        return langMap[ep.resxCulture].skillsDeleteConfirm || langMap.en.skillsDeleteConfirm;
    },
    get SnapshotsLimitError() {
        return langMap[ep.resxCulture].SnapshotsLimitError || langMap.en.SnapshotsLimitError;
    },
    get sort() {
        return langMap[ep.resxCulture].sort || langMap.en.sort;
    },
    get sort_activities() {
        return langMap[ep.resxCulture].sort_activities || langMap.en.sort_activities;
    },
    get sort_ascending() {
        return langMap[ep.resxCulture].sort_ascending || langMap.en.sort_ascending;
    },
    get sort_az() {
        return langMap[ep.resxCulture].sort_az || langMap.en.sort_az;
    },
    get sort_descending() {
        return langMap[ep.resxCulture].sort_descending || langMap.en.sort_descending;
    },
    get sort_projects() {
        return langMap[ep.resxCulture].sort_projects || langMap.en.sort_projects;
    },
    get sort_resources() {
        return langMap[ep.resxCulture].sort_resources || langMap.en.sort_resources;
    },
    get sort_za() {
        return langMap[ep.resxCulture].sort_za || langMap.en.sort_za;
    },
    get start() {
        return langMap[ep.resxCulture].start || langMap.en.start;
    },
    get start_analyze() {
        return langMap[ep.resxCulture].start_analyze || langMap.en.start_analyze;
    },
    get start_new_project() {
        return langMap[ep.resxCulture].start_new_project || langMap.en.start_new_project;
    },
    get stop_timer_title() {
        return langMap[ep.resxCulture].stop_timer_title || langMap.en.stop_timer_title;
    },
    get sub_features_list_title() {
        return langMap[ep.resxCulture].sub_features_list_title || langMap.en.sub_features_list_title;
    },
    get SystemTaskCreatorName() {
        return langMap[ep.resxCulture].SystemTaskCreatorName || langMap.en.SystemTaskCreatorName;
    },
    get Task_CanAccessBillingInformation_AccessDenied() {
        return langMap[ep.resxCulture].Task_CanAccessBillingInformation_AccessDenied || langMap.en.Task_CanAccessBillingInformation_AccessDenied;
    },
    get this_month() {
        return langMap[ep.resxCulture].this_month || langMap.en.this_month;
    },
    get this_week() {
        return langMap[ep.resxCulture].this_week || langMap.en.this_week;
    },
    get this_year() {
        return langMap[ep.resxCulture].this_year || langMap.en.this_year;
    },
    get ThresholdValueDuplicate() {
        return langMap[ep.resxCulture].ThresholdValueDuplicate || langMap.en.ThresholdValueDuplicate;
    },
    get TimeoutErrorMessage() {
        return langMap[ep.resxCulture].TimeoutErrorMessage || langMap.en.TimeoutErrorMessage;
    },
    get to() {
        return langMap[ep.resxCulture].to || langMap.en.to;
    },
    get today() {
        return langMap[ep.resxCulture].today || langMap.en.today;
    },
    get uncheck_all_label() {
        return langMap[ep.resxCulture].uncheck_all_label || langMap.en.uncheck_all_label;
    },
    get unfreeze() {
        return langMap[ep.resxCulture].unfreeze || langMap.en.unfreeze;
    },
    get UnknownErrorMessage() {
        return langMap[ep.resxCulture].UnknownErrorMessage || langMap.en.UnknownErrorMessage;
    },
    get update_date() {
        return langMap[ep.resxCulture].update_date || langMap.en.update_date;
    },
    get updated_by() {
        return langMap[ep.resxCulture].updated_by || langMap.en.updated_by;
    },
    get upgrade() {
        return langMap[ep.resxCulture].upgrade || langMap.en.upgrade;
    },
    get upgrade_to_enterprise() {
        return langMap[ep.resxCulture].upgrade_to_enterprise || langMap.en.upgrade_to_enterprise;
    },
    get usage() {
        return langMap[ep.resxCulture].usage || langMap.en.usage;
    },
    get week() {
        return langMap[ep.resxCulture].week || langMap.en.week;
    },
    get WindowUnload_UnsavedChanges() {
        return langMap[ep.resxCulture].WindowUnload_UnsavedChanges || langMap.en.WindowUnload_UnsavedChanges;
    },
    get year() {
        return langMap[ep.resxCulture].year || langMap.en.year;
    },
    get yes() {
        return langMap[ep.resxCulture].yes || langMap.en.yes;
    },
    get yesterday() {
        return langMap[ep.resxCulture].yesterday || langMap.en.yesterday;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.common = commonResx;
